// import React from "react";
// import Header from "../header/Header";
// import FooterEl from "../Footer/FooterEl";
// const Policy = () => {
//   return (
//     <>
//       <Header />

//       <div className="headLine">
//         <p className="textHeadline">User Privacy Policy</p>
//         <div className="content">
//           <p className="text">
//             <strong>Last Updated: 29 May, 2025</strong>
//             <br></br>
//             <br></br>
//             <strong>Privacy Policy</strong>
//             <br></br>
//             <br></br>
//             <strong>“Chatandmoney”, "chat&money" are one single entity.</strong>
//             <br></br>
//             <br></br>
//             We are the flagship brand of{" "}
//             <strong>Shmania Games Private Limited</strong>, offering Our
//             Services to You wherein You can also participate in various Quiz
//             Play / Contests “or” Send and Receive Questions on Our Platform. Any
//             person utilising the Platform or any of its features including
//             participation in various Quiz Play / Contests “or” Send and Receive
//             Questions being conducted on the Platform shall be bound by the
//             terms of this privacy policy (“Privacy Policy”).
//             <br></br>
//             <br></br>
//             All capitalised terms not defined herein shall have the meaning
//             ascribed to them in the Terms.
//             <br></br>
//             <br></br> We respect the privacy of its User(s) and are committed to
//             protect it in all respects. With a view to offer an enriching and
//             holistic internet experience to its Users, We offer a vast
//             repository of Services on Our Platform . Kindly take time to read
//             the “About Us” section to know more. Most of the Services are
//             offered for free but you need registration to participate in the
//             Quiz Play / Contests “or” Send and Receive Questions. The
//             information about the User(s) is collected by Us as (i) information
//             supplied by User(s) and (ii) information automatically tracked
//             during User(s)’ navigation on the Platform.
//             <br></br>
//             <br></br>Before you submit any information on the Platform, please
//             read this Privacy Policy for an explanation of how We will treat
//             Your information. By using any part of the Platform, You consent to
//             the collection, use, disclosure and transfer of Your information for
//             the purposes outlined in this Privacy Policy and to the collection,
//             processing and maintenance of this information. Your use of any part
//             of the Platform indicates Your acceptance of this Privacy Policy and
//             of the collection, use and disclosure of Your information in
//             accordance with this Privacy Policy.
//             <br></br>
//             <br></br>While You have the option not to provide Us with certain
//             personal information, withdraw Your consent to collect certain
//             information, request temporary suspension of collection of personal
//             information or request deletion of personal information collected,
//             kindly note that in such an event You may not be able to take full
//             advantage of the entire scope of features and services offered to
//             You and We reserve the right not to provide You with Our services.
//             <br></br>
//             <br></br>In the ever-evolving medium of the internet, We reserve our
//             right to periodically review and change Our Privacy Policy to
//             incorporate such future changes as may be considered appropriate and
//             under applicable laws. We will notify You of the change. Any changes
//             to Our Privacy Policy will be posted on this page, so You are always
//             aware of what information We collect, how We use it, how We store it
//             and under what circumstances We disclose it and also the date we
//             modify the Privacy Policy.
//             <br></br>
//             <br></br>
//             <strong>Purpose and Usage:</strong>
//             <br></br>
//             <br></br>To avail certain features on the Platform, Users may be
//             required to provide following information for the registration
//             process, namely:
//             <br></br>
//             <br></br>
//             1. Username
//             <br></br>2. Email address
//             <br></br>3. Date of birth
//             <br></br>4. State
//             <br></br>5. Government ID such as aadhaar card or driving license or
//             voter id
//             <br></br>6. And, other required details as per the "Law"
//             <br></br>
//             <br></br>
//             Additionally in the course of providing You with access to the
//             Platform and the Services offered by Us, You agree to give Us the
//             permission to capture and record Your device related information,
//             operating system information, network information, location
//             information etc. You may choose to allow Us to gather information in
//             relation to the apps installed on Your device in order for Us to
//             better our Services and Your experience on the Platform. You may
//             also be required to furnish additional information, including Your
//             Permanent Account Number.
//             <br></br>
//             <br></br>In certain instances, We may also collect sensitive
//             personal information from You on the Platform. SPI means such
//             personal information which consists of information relating to Your
//             financial information, such as information regarding the payment
//             instrument/modes used by You to make such payments, which may
//             include cardholder name, credit/debit card number (in encrypted
//             form) with expiration date, banking details, wallet details etc.
//             (“SPI”). This information is presented at the time of making a
//             payment to enable You to complete Your payment expeditiously.
//             <br></br>
//             <br></br>Except for any financial information that You choose to
//             provide while making payment for any Services on the Platform, We do
//             not collect any other SPI in the course of providing the Services.
//             Any SPI collected by Us shall not be disclosed to any third-party
//             service provider without Your express consent, save as otherwise set
//             out in this Privacy Policy or as provided in a separate written
//             agreement between Us and You or as required by law. It is clarified
//             that this condition shall not apply to publicly available
//             information, including SPI, in relation to You on the Platform.
//             <br></br>
//             <br></br>We collect and use personal information provided by You
//             (that is, information that may be used to identify You and that is
//             not otherwise publicly available) to operate, provide, develop, and
//             improve our Services, keeping you informed of Our offerings, and the
//             products and/or services of Our affiliates and group entities, and
//             to enable Our affiliates and group entities to reach out to You in
//             relation to the products and services offered by them.
//             <br></br>
//             <br></br>In the course of providing the Services, User(s) may invite
//             other existing User(s) or other users (“Invited Users”) to
//             participate in any of the Services through any social media platform
//             including without limitation, Facebook, WhatsApp, Instagram etc. We
//             may thereafter use this information to contact the Invited User and
//             invite such user to register with Our Platform (if such Invited User
//             is not an existing User) and participate in the Contest in relation
//             to which such person was invited by you. The participation of the
//             Invited User in any Contest shall be subject to the terms of this
//             Privacy Policy and the Terms for the use of the Platform. You hereby
//             represent that the Invited Users have consented and agreed to such
//             disclosure of their information with Us, Our affiliates and/ or Our
//             group entities. You may also choose to invite Your friends by
//             syncing your phonebook and inviting them directly from the Platform
//             to utilize Our Services and/or to play the Contests.
//             <br></br>
//             <br></br>All required information is specific and based on the kind
//             of Services and/or Contests the User wishes to participate in or
//             access, and will be utilized to provide
//             <br></br>
//             <br></br>
//             <strong>Disclosure/Sharing:</strong>
//             <br></br>
//             <br></br>
//             We may share information as provided by You and data concerning Your
//             usage of the Services and participation in the Contests with Our
//             affiliates and group entities to enable them to reach out to you in
//             relation to the products and/or services offered by them. We may
//             also share such information with third party service providers
//             engaged by Us, for the purpose of data analytics or for the purpose
//             of storage, improving the services (including product enhancements)
//             and to help Us serve you better. Provided that affiliate, group
//             entity and third-party service provider (as may be applicable) with
//             whom the information is shared will be required, on best efforts
//             basis, to comply with the same standards as applicable to Us in
//             relation to maintaining the security of the information.
//             <br></br>
//             <br></br>By using the Platform, You hereby expressly agree and grant
//             consent to the collection, use and storage of your information by
//             Us. We reserve the right to share, disclose and transfer information
//             collected hereunder with Our affiliates and group entities. In the
//             event We sell or transfer all or a portion of Our business assets,
//             consumer information may be one of the business assets that is
//             shared, disclosed or transferred as part of the transaction. You
//             hereby expressly grant consent and permission to Us for disclosure
//             and transfer of personal information for the same.
//             <br></br>
//             <br></br>We may share information and data concerning usage of the
//             Services and participation in the Contests with Our commercial
//             partners for the purpose of facilitating user engagement, for
//             marketing and promotional purposes and other related purposes.
//             <br></br>
//             <br></br>Further, We reserve the right to disclose/share information
//             with affiliates, group entities and third parties in limited
//             circumstances, including for the purposes of complying with
//             applicable law, responding to duly authorized legal process,
//             governmental requests, preventing fraud or imminent harm, and
//             ensuring the security of Our network and services.
//             <br></br>
//             <br></br>
//             <strong>Use of Cookies:</strong>
//             <br></br>
//             <br></br>
//             To improve the effectiveness and usability of the Platform for our
//             Users, We use “cookies”, or such similar electronic tools to collect
//             information to assign each visitor a unique random number as a User
//             Identification (User ID) to understand the Use’'s individual
//             interests using the identified device. Unless the User voluntarily
//             identifies himself/herself (e.g., through registration), We have no
//             way of knowing who the User is, even if we assign a cookie to the
//             User’s device. The only information a cookie can contain is
//             information supplied by the User. A cookie cannot read data off the
//             User’s device hard drive. Our advertisers may also assign their own
//             cookies to the User's device (if the User clicks on their ad
//             banners), a process that We do not control.
//             <br></br>
//             <br></br>Our web servers automatically collect limited information
//             about User’s device connection to the Internet, including User’s IP
//             address, when the User(s) uses the Platform (User's IP address is a
//             number that lets devices attached to the Internet know where to send
//             data to the User -- such as the web pages viewed by the User). The
//             User's IP address does not identify the User personally. We use this
//             information to deliver our web pages to User(s) upon request, to
//             tailor our Platform to the interests of Our User(s), to measure
//             traffic within the Platform and let advertisers know the geographic
//             locations from where Our visitors come.
//             <br></br>
//             <br></br>
//             <strong>Links:</strong>
//             <br></br>
//             <br></br>
//             We also include links to other websites. Such websites are governed
//             by their respective privacy policies, which are beyond Our control.
//             Once the User(s) leaves Our servers (the User can tell where he/she
//             is by checking the URL in the location bar on the User's browser),
//             use of any information provided by the User is governed by the
//             privacy policy of the operator of the site which the User is
//             visiting. That policy may differ from Our Privacy Policy. If the
//             User can't find the privacy policy of any of these sites via a link
//             from the site's homepage, the User may contact the site directly for
//             more information. We are not responsible for the privacy practices
//             or the content of such third-party websites.
//             <br></br>
//             <br></br>
//             <strong>Security Procedures:</strong>
//             <br></br>
//             <br></br>
//             All information gathered on Our Platform is securely stored within a
//             controlled database. The database is stored on servers secured
//             behind a firewall; access to such servers being password-protected
//             and strictly limited based on need-to-know basis. However, we
//             understand that as effective as Our security measures are, no
//             security system is impenetrable. Thus, We cannot guarantee the
//             security of Our database, nor can We guarantee that information You
//             supply will not be intercepted while being transmitted to Us over
//             the internet. Further, any information You include in a posting to
//             the discussion areas will be available to anyone with internet
//             access. By using the Platform, you understand and agree that Your
//             information may be used in or transferred to countries other than
//             India.
//             <br></br>
//             <br></br>
//             <strong>Advertising:</strong>
//             <br></br>
//             <br></br>
//             When We present information to Our online advertisers - to help them
//             understand Our audience and confirm the value of advertising on the
//             Platform - it is usually in the form of aggregated anonymized data
//             (information that cannot be used to trace a user) of User(s) that
//             may include statistics and/or data concerning User traffic, User
//             responsiveness and User behaviour to such advertisements on our
//             Platform. When you register with Us, We contact you from time to
//             time about updating Your content to provide features which we
//             believe may benefit You.
//             <br></br>
//             <br></br>
//             <strong>Disclaimer:</strong>
//             <br></br>
//             <br></br>
//             Several deceptive emails, websites, blogs etc. claiming to be from
//             or associated with Our Platform may or are circulating on the
//             Internet (“Deceptive Communication”). Such Deceptive Communication
//             may include our logo, photos, links, content or other information.
//             Some Deceptive Communication may call the User(s) requesting the
//             User(s) to provide login name, password etc. or inform the User(s)
//             that the User(s) has won a prize/ gift or provide a method to commit
//             an illegal/ unauthorized act or deed or request detailed personal
//             information or a payment of some kind. The sources and contents of
//             these Deceptive Communications and accompanying materials are in no
//             way associated with Us. For Your own protection, We strongly
//             recommend not responding to such Deceptive Communication without
//             verifying the genuineness. You agree that We shall not be liable for
//             any loss, damage and harm that You may suffer by relying and/or
//             acting upon such Deceptive Communications.
//             <br></br>
//             <br></br>Except, as provided for the purpose of verification, as set
//             out under the Terms, We and/or Our employees will not contact You to
//             divulge your SPI.
//             <br></br>
//             <br></br>
//             <strong>Conditions of Use:</strong>
//             <br></br>
//             <br></br>
//             <strong>
//               WE DO NOT WARRANT THAT THIS PLATFORM, OUR SERVERS, OR EMAIL SENT
//               BY US OR ON OUR BEHALF ARE VIRUS FREE. WE WILL NOT BE LIABLE FOR
//               ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF THIS PLATFORM,
//               INCLUDING, BUT NOT LIMITED TO COMPENSATORY, DIRECT, INDIRECT,
//               INCIDENTAL, PUNITIVE, SPECIAL AND CONSEQUENTIAL DAMAGES, LOSS OF
//               DATA, GOODWILL, BUSINESS OPPORTUNITY, INCOME OR PROFIT, LOSS OF OR
//               DAMAGE TO PROPERTY AND CLAIMS OF THIRD PARTIES. IN NO EVENT WILL
//               WE BE LIABLE FOR ANY DAMAGES WHATSOEVER IN AN AMOUNT IN EXCESS OF
//               AN AMOUNT OF INR 100.
//             </strong>
//             <br></br>
//             <br></br>
//             <strong>Retention of Data:</strong>
//             <br></br>
//             <br></br>
//             Your personal information may be retained and may continue to be
//             used until: (i) the relevant purposes for the use of Your personal
//             information described in this Privacy Policy are no longer
//             applicable; and (ii) We are no longer required by applicable law,
//             regulations, contractual obligations or legitimate business purposes
//             to retain Your personal information and the retention of Your
//             personal information is not required for the establishment, exercise
//             or defense of any legal claim.
//             <br></br>
//             <br></br>
//             <strong>User Account and Data Deletion:</strong>
//             <br></br>
//             <br></br>
//             User(s) are entitled to request Us to delete their accounts and
//             their personal information by clicking on Help & Support.
//             <br></br>
//             <br></br>We will do our best to respond promptly and in any event
//             within one month of the following:
//             <br></br>
//             <br></br>• - Our receipt of Your written request; or
//             <br></br>
//             <br></br>• - Our receipt of any further information We may ask you
//             to provide, to enable Us to comply with Your request, whichever is
//             later.
//             <br></br>
//             <br></br>You also have the option to request either:
//             <br></br>
//             i. the suspension of Your account, after which You will not be able
//             to play paid contests on your User account but will continue to have
//             access to other parts of the Platform; or
//             <br></br>
//             ii. temporary deactivation of Your account, where you will no longer
//             be able to log into the Platform but which allows You to request
//             reactivation of your account with all Your account data.
//             <br></br>
//             <br></br>
//             If You proceed with permanent deactivation of your account, you will
//             lose access to the Platform and the Services, including any User
//             data and personal information associated with Your account. User(s)
//             may request for account restoration within six (6) months from the
//             date of notification of account deletion by clicking on Help &
//             Support.
//             <br></br>
//             <br></br>
//             When You request deletion of Your data, We follow a deletion process
//             that ensures that Your data is safely and completely removed from
//             Our servers or retained only in anonymised form. We try to ensure
//             that Our services protect information from accidental or malicious
//             deletion. Because of this, there may be delays between when You
//             request deletion and when copies are deleted from our active and
//             backup systems.
//             <br></br>
//             <br></br>
//             <strong>Applicable Law and Jurisdiction:</strong>
//             <br></br>
//             <br></br>
//             By visiting this Platform, you agree that the laws of the Republic
//             of India without regard to its conflict of laws principles, govern
//             this Privacy Policy and any dispute arising in respect hereof shall
//             be subject to and governed by the dispute resolution process set out
//             in the Terms.
//             <br></br>
//             <br></br>
//             <strong>Updating Information:</strong>
//             <br></br>
//             <br></br>
//             You will promptly notify Us if there are any changes, updates or
//             modifications to Your personal information. Further, You may also
//             review, update or modify Your personal information and User
//             preferences by logging into Your profile page on the Platform.
//             <br></br>
//             <br></br>
//             <strong>Contact Us:</strong>
//             <br></br>
//             <br></br>
//             Any questions or clarifications with respect to this Privacy Policy
//             or any complaints, comments, concerns or feedback can be sent to Us
//             by clicking on Help & Support or by normal/physical mail addressed
//             to:
//             <br></br>
//            To : <strong>Chatandmoney Team</strong>
//             <br></br>
//             <strong>Shmania Games Private Limited,</strong>
//             <br></br>
//             <strong>40/45 Shiv Shakti Nagar Meerut U.P. 25002 INDIA,</strong>
//             <br></br>
//             <br></br>
//           </p>
//         </div>
//       </div>
//       <FooterEl />
//     </>
//   );
// };

// export default Policy;

import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="privacy-container">
      <style>{`
        .privacy-container {
          max-width: 800px;
          margin: 0 auto;
          padding: 2rem;
          font-family: system-ui, sans-serif;
          background: #ffffff;
          color: #1a1a1a;
          line-height: 1.6;
          box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
        }
        .privacy-container h1 {
          font-size: 2rem;
          font-weight: bold;
          margin-bottom: 0.5rem;
          color:#6b4fff;
        }
        .privacy-container h2 {
          font-size: 1.25rem;
          font-weight: 600;
          margin: 1.5rem 0 0.5rem;
          
        }
        .privacy-container p {
          margin-bottom: 1rem;
        }
        .privacy-container ul {
          margin-left: 1.2rem;
          margin-bottom: 1rem;
        }
        .privacy-container li {
          margin-bottom: 0.5rem;
        }
        .privacy-container a {
          color: #2563eb;
          text-decoration: underline;
        }
        .privacy-container small {
          display: block;
          margin-top: 2rem;
          font-size: 0.8rem;
          color: #666;
        }
        /* Dark theme */
        @media (prefers-color-scheme: dark) {
          .privacy-container {
            background: #0f172a;
            color: #e5e7eb;
          }
          .privacy-container a {
            color: #60a5fa;
          }
          .privacy-container small {
            color: #9ca3af;
          }
        }
      `}</style>

      <h1>Privacy Policy</h1>
      <p>
        <small>Last updated: January 27, 2026</small>
      </p>
      <strong>Games/Apps that we support in our Privacy Policy.</strong>
      <p>
        <strong>1. PickMe Game App</strong>
      </p>
      <p>
        <strong>2. NumberMe Game App</strong>
      </p>
      <p>
        <strong>3. ChatAndQuiz Game App</strong>
      </p>
      <p>
        (“we,” “our,” or “us”) values your privacy. This Privacy Policy explains
        how we collect, use, and protect your information when you use our
        mobile application (“App”).
      </p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li>Personal Information (e.g., name, email address if provided)</li>
        <li>Usage Data (e.g., app interactions, performance metrics)</li>
        <li>
          Device Data (e.g., device model, OS version, crash logs, IP address)
        </li>
        <li>Permissions (if granted, e.g., camera, location)</li>
      </ul>

      <h2>2. How We Use Information</h2>
      <ul>
        <li>Provide, operate, and improve the App</li>
        <li>Personalize content and features</li>
        <li>Analyze performance and fix bugs</li>
        <li>Communicate updates or support responses</li>
        <li>Deliver ads (if applicable)</li>
      </ul>

      <h2>3. Sharing of Information</h2>
      <p>
        We do not sell or rent your personal information. We may share data only
        with:
      </p>
      <ul>
        <li>Service providers (e.g., hosting, analytics, crash reporting)</li>
        <li>Authorities if required by law</li>
        {/* <li>A buyer/successor in the event of a merger or acquisition</li> */}
      </ul>

      <h2>4. Third-Party Services</h2>
      <p>
        Our App may use third-party services that collect information.We
        directly do not give access to those services examples are : Firebase,
        Admob.{" "}
      </p>

      <h2>5. Data Retention</h2>
      <p>
        We retain information only as long as necessary to provide the App and
        fulfill the purposes in this policy, unless longer retention is required
        by law.
      </p>

      <h2>6. Security</h2>
      <p>We use reasonable safeguards to protect your data.</p>

      <h2>7. Your Rights</h2>
      <ul>
        <li>Request access, correction, or deletion of your personal data</li>
        <li>Opt out of analytics or advertising (if applicable)</li>
        <li>Revoke app permissions via your device settings</li>
      </ul>

      <h2>8. Children’s Privacy</h2>
      <p>
        This App is not directed to children under 13 (or under 16 in some
        regions). We do not knowingly collect information from children.
      </p>

      <h2>9. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Updates will be
        posted here with a new “Last updated” date.
      </p>

      <h2>10. Contact Us</h2>
      <p>
        If you have questions, contact us at{" "}
        <a href="mailto:shmania.games@gmail.com">shmania.games@gmail.com</a>.
      </p>

      <small>
        Note: This may not cover all legal requirements.
      </small>
    </div>
  );
}
